import styled from 'styled-components';

import media from '../../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH } from '../../../styles/variables.style';

export const SlideContent = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
`;

export const SliderPlaceholder = styled.div`
  margin: auto;
  max-width: 1050px;
`;

export const Section = styled.section`
  overflow-x: hidden;
  padding: 10px 15px 100px;
  position: relative;

  ${media.tabletL`
    padding: 0 0 100px;
  `};
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const ImageWrapper = styled.div`
  & > div > img {
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled.h1`
  color: #282828;
  display: flex;
  font-size: 34px;
  justify-content: center;
  margin: 30px 0 10px 0;
  text-align: center;
  text-transform: uppercase;

  ${media.tabletL`
    margin: 60px auto 10px;
    max-width: 950px;
    width: 75%;
  `};
`;

export const Text = styled.div`
  font-size: 16px;
  text-align: left;
  color: #282828;
  margin: 0 auto;
  text-align: center;

  ${media.tabletL`
    max-width: 950px;
    width: 75%;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/HomePage/BrandManifesto/BrandManifesto.style.js